import React from 'react';
import { BsCpu, BsEye } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Grid, GridItem, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import UserIcon from '../../../../../../../components/UserIcon';
import { analyticsIds } from '../../../../../../../constants/analyticsIds';
import { showModal } from '../../../../../../../redux/modules/modal';
import colors from '../../../../../../../styles/theme/foundation/colors';
import { formatDateTimeToClientLocal } from '../../../../../../../utils/dateUtil';
import ViewEmailModal from '../../../../modals/ViewEmailModal';

const EmailHistoryRow = ({ email }) => {
  const { senderType, sender, id, createdAt, insuranceRequirement, to, subject, migrationId } = email;
  const dispatch = useDispatch();
  const convertedDate = formatDateTimeToClientLocal(createdAt, 'MM/DD/YYYY');

  const getUserIcon = () => {
    if (email?.emailAutomationEmail) {
      return (
        <Tooltip hasArrow label="PINS Email Automation">
          <Box>
            <Icon as={BsCpu} boxSize="20px" color={colors.primaryScale['600']} ml="2px" />
          </Box>
        </Tooltip>
      );
    }

    if (senderType === 'user' && sender) {
      return (
        <UserIcon
          firstName={sender?.userFirstName}
          lastName={sender?.userLastName}
          ml="0px"
        />
      );
    }

    if (senderType === 'user' && migrationId) {
      return (
        <UserIcon
          firstName="PINS"
          lastName="Migration"
          ml="0px"
        />
      );
    }

    return <UserIcon firstName="PINS" lastName="System" ml="0px" />;
  };

  return (
    <Box
      bg="white"
      borderRadius="md"
      boxShadow="base2"
      mb={4}
      px={2}
      py={4}
    >
      <Grid
        alignItems="center"
        gap={6}
        templateColumns="repeat(20, 1fr)"
        textAlign="left"
        textStyle="bodyMd"
      >
        <GridItem colSpan={2}>{convertedDate}</GridItem>
        <GridItem colSpan={1}>{getUserIcon()}</GridItem>
        <GridItem colSpan={5}>{to}</GridItem>
        <GridItem colSpan={6}>{subject}</GridItem>
        <GridItem colSpan={5}>{insuranceRequirement?.job?.jobName ?? '-'}</GridItem>
        <GridItem colSpan={1}>
          <IconButton
            aria-label="show-email-icon-button"
            colorScheme="brand"
            data-analytics-id={analyticsIds.insuredProfilePage.policiesComponent.emailHistoryTray.openViewEmailButton}
            icon={<Icon as={BsEye} boxSize={6} />}
            variant="accent"
            onClick={() => dispatch(showModal(ViewEmailModal, {
              center: false,
              size: '5xl',
              title: null
            }, { email }))}
          />
        </GridItem>
      </Grid>
    </Box>
  );
};

EmailHistoryRow.propTypes = {
  email: PropTypes.shape({
    id: PropTypes.number,
    createdAt: PropTypes.string.isRequired,
    to: PropTypes.string,
    subject: PropTypes.string,
    insuranceRequirement: PropTypes.shape({ job: PropTypes.shape({ jobName: PropTypes.string }) }),
    senderType: PropTypes.string.isRequired,
    sender: PropTypes.shape({
      userFirstName: PropTypes.string,
      userLastName: PropTypes.string
    }),
    migrationId: PropTypes.number,
    emailAutomationEmail: PropTypes.shape({})
  })
};

export default EmailHistoryRow;
